import * as React from 'react';
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import Box from "@mui/material/Box/Box";
import Grid from "@mui/material/Grid/Grid";
import {useIntl} from 'react-intl'
import { styled } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from "@mui/material/TextField/TextField";
import Button from "@mui/material/Button/Button";
import {SelectChangeEvent} from "@mui/material";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import Chip from "@mui/material/Chip/Chip";
import {AuthUserContext} from "../providers/AuthProvider";
import firebase from '../firebase/firebase'
import {useNavigate} from "react-router-dom";


export default function InterestsComponent({parentCallback}) {
  const Input = styled('input')({
    display: 'none',
  })
  const {messages} = useIntl()
  const navigator= useNavigate()
  const [genre, setGenre] = React.useState([]);
  const [tags, setTags] = React.useState([]);
  const [lang, setLang] = React.useState([]);
  const [stage, setStage] = React.useState([]);
  const { user, profile } = React.useContext(AuthUserContext);
  const [mode, setMode] = React.useState('self')
  const preTags = [
    'Feature Films',
    'Documentaries',
    'Animations',
    'Indie Shorts',
    'Anime',
    'TV Drama',
    'Comedy',
    'Horror',
    'Kdrama',
    'Cdrama',
    'Other',
    'All',
  ];

  const geoTags = [
    'Asia',
    'Europe',
    'America',
    'Africa',
    'Australia',
    'South Korea',
    'China',
    'India',
    'Nigeria',
    'Spain',
    'U.K',
    'U.S.A',
    'Brazil',
    'Other',
    'All',
  ];
  const language = [
    'Chinese', 'English'
  ];
  const stages = [
    'Pre Production',
    'Production',
    'Post Production',
  ];
  const handleChange = (event: SelectChangeEvent<typeof genre>) => {
    const {
      target: { value },
    } = event;
    setGenre(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleChangeTags  = (event: SelectChangeEvent<typeof tags>) => {
    const {
      target: { value },
    } = event;
    setTags(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  const handleChangeLanguage = (event: SelectChangeEvent<typeof lang>) => {
    const {
      target: { value },
    } = event;
    setLang(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleChangeStage = (event: SelectChangeEvent<typeof stage>) => {
    const {
      target: { value },
    } = event;
    setStage(value)
    // setStage(
    //   // On autofill we get a stringified value.
    //   typeof value === 'string' ? value.split(',') : value,
    // );
  };

  const changesSave = async () => {

    const userRef = firebase.firestore().collection('users').doc(profile.id);
    const userDoc = await userRef.update({interests: {genre, geography: tags, language: lang, stage}});
    parentCallback('activities')
  }
  React.useEffect(() => {
    const userRef = firebase.firestore().collection('users').doc(profile.id);
    userRef.get().then((d) => {
      if(d.data().interests) {
        const {genre, geography, language, stage} = d.data().interests;
        setGenre(genre)
        setTags(geography)
        setLang(language)
        setStage(stage)
        setMode('self')
      }
      else{
        setMode('edit')
      }
    })
  }, [])
  return (

    <Container maxWidth="md" component="main" sx={{textAlign:'left', mt:5, pb:5}}>
      <Grid  container
      >
  
      <Grid xs={12} > 

          <Stack direction="column"
                 spacing={3}
                 sx={{width: '100%', mb: 5}}>
            <Stack
								sx={{
									display: "flex",
									alignItems: "flex-end",
								}}>
								{mode === "self" && (
									<Button
										onClick={(e) => setMode("edit")}
										sx={{fontFamily: "ABeeZee", py: 0.5, px: 5, width: "25%", textTransform: "none" }}
										variant={"outlined"}
										startIcon={
											<img
												src={
													"/assets/icons/pencil-edit.png"
												}
											/>
										}>
										Edit info
									</Button>
								)}
							</Stack>
            <Typography variant={'h5'} color={'primary'} sx={{borderBottom: '1px solid #204488'}}>
              INTERESTS
            </Typography>
            <span />
            {mode==='edit' && <TextField
              label={'Select genre'}
              select
              sx={{textAlign:'left'}}
              SelectProps={{
                multiple: true,
                value: genre,
                onChange: handleChange
              }}>
              {preTags.map((t) => <MenuItem value={t}>{t}</MenuItem>)}
            </TextField>}
            {genre.length > 0 &&(
              mode ==="edit"?<>
              <Grid container  spacing={2} >
              {genre.length > 0 && genre.map((d) =>  <Chip
               label={d} xs={2} variant="contained" sx={{fontFamily: "ABeeZee",backgroundColor:'#E3E8F0', color: "#204488",marginLeft:"5px",marginRight:"5px",marginBottom:"10px"}} onDelete={()=> setGenre(genre.filter((f) => f !== d )) } />)}
              </Grid>
              </>
              :
              <>
              <Typography  sx={{color: "#204488",marginRight:"40px"}}>Genre</Typography>
              <Grid container  spacing={2} >
              
             
              {genre.length > 0 && genre.map((d) => 
                
               <Chip xs={2} label={d} 
                
                variant="contained" sx={{fontFamily: "ABeeZee",color: "#204488", fontSize:"16px" , pl:2, pr:2, backgroundColor:'#E3E8F0',marginLeft:"5px",marginRight:"5px",marginBottom:"10px"}}/>
            
               )}
               </Grid>
              </>)
            }
            {genre.length > 0 &&
            <span />
            }
            {mode==="edit" && <TextField
              label={'Select geography'}
              select
              sx={{textAlign:'left'}}
              SelectProps={{
                multiple: true,
                value: tags,
                onChange: handleChangeTags
              }}>
              {geoTags.map((t) => <MenuItem value={t}>{t}</MenuItem>)}
            </TextField>}
            {tags.length > 0 &&
            (mode==="edit" ? <>
            <Grid container  spacing={2} >
              
          
              {tags.length > 0 && tags.map((d) =>  <Chip xs={2}
               label={d} variant="contained" sx={{fontFamily: "ABeeZee",color: "#204488", backgroundColor:'#E3E8F0',marginLeft:"5px",marginRight:"5px",marginBottom:"10px"}} onDelete={()=> setTags(tags.filter((f) => f !== d )) } />)}

              </Grid>
            </>
            : 
            <>
            <Typography  sx={{color: "#204488",marginRight:"40px"}}>Geography</Typography>
            <Grid container  spacing={2} >
              
             
              {tags.length > 0 && tags.map((d) => 
                
               <Chip xs={2} label={d} 
              
                variant="contained" sx={{fontFamily: "ABeeZee", color: "#204488", fontSize:"16px" , pl:2, pr:2, backgroundColor:'#E3E8F0',marginLeft:"5px",marginRight:"5px",marginBottom:"10px"}}/>
            
               )}
               </Grid>
            </>
              
            ) 
            }
            {tags.length > 0 &&
            <span />
            }
            
            {mode==="edit" && <TextField
              label={'Select Language'}
              select
              sx={{textAlign:'left'}}
              SelectProps={{
                multiple: true,
                value: lang,
                onChange: handleChangeLanguage
              }}>
              {language.map((t) => <MenuItem value={t}>{t}</MenuItem>)}
            </TextField>}
            {lang.length > 0 &&
            (mode==="edit" ? <>
            <Stack direction="row" spacing={1}>
          
              {lang.length > 0 && lang.map((d) =>  <Chip label={d} variant="contained" sx={{fontFamily: "ABeeZee", backgroundColor:'#E3E8F0'}} onDelete={()=> setLang(lang.filter((f) => f !== d )) } />)}

            </Stack>
            </>
            : 
            <>
            <Typography sx={{mr:2, color: "#204488"}}>Language</Typography>
            <Stack direction="row" spacing={1}>
         
              {lang.length > 0 && lang.map((d) =>  <Chip label={d} variant="contained" sx={{fontFamily: "ABeeZee", color: "#204488", fontSize:"16px" , pl:2, pr:2, backgroundColor:'#E3E8F0'}}/>)}
              </Stack></>) 
            }
            {lang.length > 0 &&
            <span />
            }

            {mode==="edit" && <TextField
              label={'Select Stage'}
              select
              sx={{textAlign:'left'}}
              SelectProps={{
                value: stage,
                onChange: handleChangeStage
              }}>
              {stages.map((t) => <MenuItem value={t}>{t}</MenuItem>)}
            </TextField>}
            {stage.length > 0 &&
            (mode==="edit" ? <>
            <Stack direction="row" spacing={1}>
          
              <Chip label={stage} variant="contained" sx={{fontFamily: "ABeeZee",backgroundColor:'#E3E8F0'}} onDelete={()=> setStage("") } />

            </Stack>
            </>
            : 
            <>
            <Typography sx={{mr:2, color: "#204488"}}>Stage</Typography>
            <Stack direction="row" spacing={1}>
              <Chip label={stage} variant="contained" sx={{fontFamily: "ABeeZee",color: "#204488", fontSize:"16px" , pl:2, pr:2, backgroundColor:'#E3E8F0'}}/>
              </Stack></>)
            }
            {stage.length > 0 &&
            <span />
            }

            {
            /* <TextField
              label={'Select Language'}
              select
              sx={{textAlign:'left'}}
              SelectProps={{
                multiple: true,
                value: lang,
                onChange: handleChangeLanguage
              }}>
              {language.map((t) => <MenuItem value={t}>{t}</MenuItem>)}
            </TextField>
            {lang.length > 0 &&

            <Stack direction="row" spacing={1}>
              {lang.length > 0 && lang.map((d) =>  <Chip label={d} variant="contained" sx={{backgroundColor:'#E3E8F0'}} onDelete={()=> setLang(lang.filter((f) => f !== d )) } />)}

            </Stack>
            }
            {lang.length > 0 &&
            <span />
            }

            <TextField
              label={'Select Stage'}
              select
              sx={{textAlign:'left'}}
              SelectProps={{
                multiple: true,
                value: stage,
                onChange: handleChangeStage
              }}>
              {stages.map((t) => <MenuItem value={t}>{t}</MenuItem>)}
            </TextField>
            {stage.length > 0 &&

            <Stack direction="row" spacing={1}>
              {stage.length > 0 && stage.map((d) =>  <Chip label={d} variant="contained" sx={{backgroundColor:'#E3E8F0'}} onDelete={()=> setStage(stage.filter((f) => f !== d )) } />)}

            </Stack>
            } */}

            { mode === "edit" ? 
            <>
              <Stack spacing={2} direction="row" sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <Button  sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,  textDecoration:'underline'}}  onClick={() => setMode('self')}>Quit without saving</Button>

              <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,backgroundColor:'#FD4A01'}} color={'warning'} onClick={changesSave} >Save Changes</Button>
            </Stack>
            </> : <></>}
            

          </Stack>

        </Grid>
      </Grid>
    </Container>
  );


}